var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('h6',[_vm._v("AFK Design & Web 2021 © Wszelkie prawa zastrzeżone.")])])}]

export { render, staticRenderFns }